module.exports = __webpack_public_path__ + "img/feiliao.a8124833.png";